import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Users from '../Pages/Users/Users'
import UserStats from '../Pages/Users/UserStats'

const UsersRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<Users />} />
      {/* New project-based user stats route */}
      <Route path=':userId/stats/:projectKey' element={<UserStats />} />
    </Routes>
  )
}

export default UsersRoutes
